import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import HeaderTwo from '../../components/mondiya/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/mondiya/Breadcrumb';
import GoogleMap from './GoogleMap';
import FooterTwo from '../../components/mondiya/FooterTwo';
import { Styles } from './styles/mondiya/contact.js';
import emailjs from 'emailjs-com';
import {useTranslation} from "react-i18next";

function Contact() {
    const { t } = useTranslation();

    useEffect(() => {
        const form = document.getElementById("form_contact");
        const name = document.getElementById("contact_name");
        const email = document.getElementById("contact_email");
        const phoneNumber = document.getElementById("contact_phone");
        const subject = document.getElementById("contact_subject");
        const message = document.getElementById("contact_message");
        const honeypot = document.querySelector('input[name="company_website"]');

        if (!form) return;

        form.addEventListener("submit", formSubmit);

        // Form Submit Handler
        function formSubmit(e) {
            e.preventDefault();

            const nameValue = name.value.trim();
            const emailValue = email.value.trim();
            const phoneNumberValue = phoneNumber.value.trim();
            const subjectValue = subject.value.trim();
            const messageValue = message.value.trim();

            // Honeypot check (bot submissions)
            if (honeypot && honeypot.value) {
                return;
            }

            // Validate fields
            if (nameValue === "") {
                setError(name, "Name can't be blank");
            } else {
                setSuccess(name);
            }

            if (emailValue === "") {
                setError(email, "Email can't be blank");
            } else if (!isEmail(emailValue)) {
                setError(email, "Not a valid email");
            } else {
                setSuccess(email);
            }

            if (subjectValue === "") {
                setError(subject, "Subject can't be blank");
            } else {
                setSuccess(subject);
            }

            if (messageValue === "") {
                setError(message, "Message can't be blank");
            } else {
                setSuccess(message);
            }

            // Validate phone number (only integers, 11 digits)
            if (phoneNumberValue === "") {
                setError(phoneNumber, "Phone number can't be blank");
            } else if (!/^\d{11}$/.test(phoneNumberValue)) {
                setError(phoneNumber, "Phone number must be 11 digits and contain only numbers");
            } else {
                setSuccess(phoneNumber);
            }

            // If no errors, send the email
            if (nameValue && emailValue && subjectValue && messageValue && phoneNumberValue && /^\d{11}$/.test(phoneNumberValue)) {
                emailjs.sendForm(
                    'service_psjkhj3', // Your Service ID
                    'template_jxhtdvj', // Your Template ID
                    form,
                    'tAiy3dVRCDbQqBcT2' // Your Public Key
                ).then(
                    (result) => {
                        alert("Message Sent Successfully!");
                        form.reset(); // Reset the form
                    },
                    (error) => {
                        alert("Error sending message. Please try again.");
                    }
                );
            }
        }

        // Set error message
        function setError(input, message) {
            const formControl = input.parentElement;
            const errorMsg = formControl.querySelector(".contact_input-msg");
            formControl.className = "form-control text-left error";
            errorMsg.innerText = message;
        }

        // Set success class
        function setSuccess(input) {
            const formControl = input.parentElement;
            formControl.className = "form-control success";
        }

        // Email validation
        function isEmail(email) {
            return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email);
        }
    }, []);

    return (
        <Styles>
            {/* Main Wrapper */}
            <div className="main-wrapper contact-page">

                {/* Header 2 */}
                <HeaderTwo />

                {/* Breadcrumb */}
                <BreadcrumbBox title={t(`contactForm.breadcrumbs`)} />

                {/* Contact Area */}
                <section className="contact-area">
                    <Container>
                        <Row>
                            <Col md="4">
                                <div className="contact-box-title">
                                    <h4>{t(`contactForm.contactInfo`)}</h4>
                                </div>
                                <div className="contact-icon-box d-flex">
                                    <div className="icon">
                                        <i className="las la-map-marker"></i>
                                    </div>
                                    <div className="box-content">
                                        <h5>{t(`contactForm.locationTitle`)}</h5>
                                        <p>{t(`contactForm.location`)}</p>
                                    </div>
                                </div>
                                <div className="contact-icon-box d-flex">
                                    <div className="icon">
                                        <i className="las la-envelope-open"></i>
                                    </div>
                                    <div className="box-content">
                                        <h5>{t(`contactForm.emailTitle`)}</h5>
                                        <p dangerouslySetInnerHTML={{ __html: t('contactForm.email') }} />
                                    </div>
                                </div>
                                <div className="contact-icon-box d-flex">
                                    <div className="icon">
                                        <i className="las la-phone"></i>
                                    </div>
                                    <div className="box-content">
                                        <h5>{t(`contactForm.phoneTitle`)}</h5>
                                        <p>{t(`contactForm.phone`)}</p>
                                    </div>
                                </div>
                            </Col>
                            <Col md="8">
                                <div className="contact-form">
                                    <div className="form-title">
                                        <h4>{t(`contactForm.getTouch`)}</h4>
                                    </div>
                                    <div className="form-box">
                                        <form id="form_contact" className="form">
                                            <Row>
                                                <Col md="12">
                                                    <p className="form-control">
                                                        <input type="text" placeholder={t(`contactForm.cName`)} id="contact_name" name="name" required />
                                                        <span className="contact_input-msg"></span>
                                                    </p>
                                                </Col>
                                                <Col md="12">
                                                    <p className="form-control">
                                                        <input type="email" placeholder={t(`contactForm.cAddress`)} id="contact_email" name="email" required />
                                                        <span className="contact_input-msg"></span>
                                                    </p>
                                                </Col>
                                                <Col md="12">
                                                    <p className="form-control">
                                                        <input
                                                            type="text"
                                                            name="phone_number"
                                                            placeholder={t(`contactForm.cPhone`)}
                                                            id="contact_phone"
                                                            required
                                                        />
                                                        <span className="contact_input-msg"></span>
                                                    </p>
                                                </Col>
                                                <Col md="12">
                                                    <p className="form-control">
                                                        <input type="text" placeholder={t(`contactForm.cSubject`)} id="contact_subject" name="subject" required />
                                                        <span className="contact_input-msg"></span>
                                                    </p>
                                                </Col>
                                                <Col md="12">
                                                    <p className="form-control">
                                                        <textarea name="message" id="contact_message" placeholder={t(`contactForm.cMessage`)} required></textarea>
                                                        <span className="contact_input-msg"></span>
                                                    </p>
                                                </Col>
                                                {/* Honeypot field (kept for bot protection) */}
                                                <Col md="12">
                                                    <p className="form-control" style={{ display: 'none' }}>
                                                        <input type="text" name="company_website" tabIndex="-1" autoComplete="off" />
                                                        <span className="contact_input-msg"></span>
                                                    </p>
                                                </Col>
                                                <Col md="12">
                                                    <button>{t(`contactForm.qSubmit`)} </button>
                                                </Col>
                                            </Row>
                                        </form>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>

                    {/* Google Map */}
                    <GoogleMap />
                </section>

                {/* Footer 2 */}
                <FooterTwo />

            </div>
        </Styles>
    );
}
export default Contact;